import React from 'react';
import MarkdownMessage from '../MarkdownMessage/MarkdownMessage';

interface ChatMessageResponseBlock {
  id: number;
  originalTextContent: string;
  translatedTextContent: string;
  category: string;
}

interface BotMessageProps {
  block: ChatMessageResponseBlock;
  blockIndex: number;
  showTranslated: boolean;
}

function BotMessage({
  block,
  blockIndex,
  showTranslated
}: BotMessageProps): React.ReactElement {
  const displayText = showTranslated
    ? block.originalTextContent
    : block.translatedTextContent;

  return (
    <div
      data-testid='bot-message-container'
      className='flex relative py-[3.2px]'
    >
      <div
        className='[&_ul]:list-inside [&_ol]:list-inside w-fit px-3 py-2 max-w-[70%] rounded-tl rounded-tr rounded-bl break-words cursor-auto bg-gray-100'
        key={blockIndex}
      >
        <MarkdownMessage isUser={false}>{displayText}</MarkdownMessage>
      </div>
    </div>
  );
}

export default BotMessage;
